<template>
    <div class="or-input">
        <p class="title">{{options.title}}</p>
        <input ref="input" :class="['input', {'error-input': error}]" :type="options.type" :required="options.required" :placeholder="options.placeholder"/>
    </div>
</template>

<script>
export default {
    props: {
        options: Object,
        error: Boolean,
    },
}
</script>

<style scoped>
    .or-input {
        margin-bottom: 20px;
    }
    .title {
        text-align: left;
        font-size: 14px;
        line-height: 21px;
        color: #EBB932;
        margin-bottom: 10px;
    }
    .input {
        width: 400px;
        height: 44px;
        background-color: #353535;
        color: white;
        padding: 12px;
        box-sizing: border-box;  
        border-radius: 8px;
        border: none;
        outline: none;
        font-size: 14px;
    }
    .input::placeholder {
        color: white;
    }
    .error-input {
        box-sizing: border-box;
        border: #932727 1px solid !important;
    }
</style>